import React from "react";

export const ReturnPolicy = () => {
  return (
    <section id="privacy-section" className="privacy container">
      <h2 className="privacy__title">Xkei Wellness – Return Policy</h2>

      <p className="privacy__text">
        At XKEI Wellness, your satisfaction is our priority. If you are not fully
        satisfied with your purchase, we offer a simple and transparent return
        process.
      </p>

      <h3 className="privacy__heading">✔️ Return Eligibility</h3>
      <ul className="privacy__list">
        <li>The seal of the product is not torn / broken</li>
        <li>The product packaging is not damaged</li>
        <li>The item is in its original condition and unused</li>
        <li>Original invoice and order details must be provided</li>
      </ul>

      <h3 className="privacy__heading">✔️ Non-Returnable Items</h3>
      <ul className="privacy__list">
        <li>Products with broken seals</li>
        <li>Used or tampered items</li>
        <li>Items damaged due to mishandling after delivery</li>
        <li>Free gifts or promotional samples</li>
      </ul>

      <h3 className="privacy__heading">✔️ Refund Process</h3>
      <p className="privacy__text">
        Once we receive the returned product and complete quality checking,
        we will initiate the refund within 7 business days. Refund will be
        credited to your original payment method.
      </p>

      <h3 className="privacy__heading">✔️ How to Request a Return</h3>
      <p className="privacy__text">
        To initiate a return, contact us through:
      </p>

      <ul className="privacy__list">
        <li>Email: letusknow.xkeiwellness@gmail.com</li>
        <li>WhatsApp / Phone: 8589833066</li>
      </ul>

      <p className="privacy__text">
        Our support team will guide you through the process.
      </p>
    </section>
  );
};
